export const WISESHEETS_API_URL = 'https://internal.wisesheets.io'
// export const WISESHEETS_API_URL = 'http://localhost:4000'
